export const USER_TYPES = [
    { name: 'Partners', value: 'partners', id:'data-qa-partner' },
    { name: 'Customer Support',  value: 'customer_support', id:'data-qa-cs'},
    { name: 'Admin Users',  value: 'admin_users', id:'data-qa-admin'},
    { name: 'Retailers',  value: 'retailers', id:'data-qa-retailer'}
];